function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M129.424 17.912V35H127.12L117.904 23.024V35H115.024V17.912H117.328L126.52 29.864V17.912H129.424ZM143.965 22.88V35H141.037V33.128C140.653 33.8 140.141 34.312 139.501 34.664C138.861 35.016 138.125 35.192 137.293 35.192C134.333 35.192 132.853 33.528 132.853 30.2V22.88H135.829V30.224C135.829 31.104 136.005 31.752 136.357 32.168C136.725 32.584 137.285 32.792 138.037 32.792C138.917 32.792 139.621 32.504 140.149 31.928C140.677 31.352 140.941 30.584 140.941 29.624V22.88H143.965ZM151.038 25.136V30.56C151.038 31.984 151.702 32.696 153.03 32.696C153.398 32.696 153.798 32.632 154.23 32.504V34.88C153.702 35.072 153.062 35.168 152.31 35.168C150.934 35.168 149.878 34.784 149.142 34.016C148.406 33.248 148.038 32.144 148.038 30.704V25.136H145.71V22.88H148.038V19.928L151.038 18.92V22.88H154.254V25.136H151.038ZM162.844 22.592C163.308 22.592 163.708 22.656 164.044 22.784L164.02 25.52C163.508 25.312 162.98 25.208 162.436 25.208C161.412 25.208 160.628 25.504 160.084 26.096C159.556 26.688 159.292 27.472 159.292 28.448V35H156.316V26.312C156.316 25.032 156.252 23.888 156.124 22.88H158.932L159.172 25.016C159.476 24.232 159.956 23.632 160.612 23.216C161.268 22.8 162.012 22.592 162.844 22.592ZM165.714 22.88H168.69V35H165.714V22.88ZM168.858 17.384V20.336H165.522V17.384H168.858ZM183.444 22.904L178.14 35H175.524L170.292 22.904H173.436L176.916 31.592L180.468 22.904H183.444ZM196.043 22.88V35H193.115V33.128C192.731 33.8 192.219 34.312 191.579 34.664C190.939 35.016 190.203 35.192 189.371 35.192C186.411 35.192 184.931 33.528 184.931 30.2V22.88H187.907V30.224C187.907 31.104 188.083 31.752 188.435 32.168C188.803 32.584 189.363 32.792 190.115 32.792C190.995 32.792 191.699 32.504 192.227 31.928C192.755 31.352 193.019 30.584 193.019 29.624V22.88H196.043ZM205.828 22.592C206.292 22.592 206.692 22.656 207.028 22.784L207.004 25.52C206.492 25.312 205.964 25.208 205.42 25.208C204.396 25.208 203.612 25.504 203.068 26.096C202.54 26.688 202.276 27.472 202.276 28.448V35H199.3V26.312C199.3 25.032 199.236 23.888 199.108 22.88H201.916L202.156 25.016C202.46 24.232 202.94 23.632 203.596 23.216C204.252 22.8 204.996 22.592 205.828 22.592ZM220.897 22.904L215.593 35H212.977L207.745 22.904H210.889L214.369 31.592L217.921 22.904H220.897Z",
  fill: "#363537"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.6027 36.465C44.8051 29.3843 44.1897 37.4469 41.6218 37.4469C39.7748 37.4469 39.5506 36.5056 39.0377 40.1309L35.5211 42.0948L19.5607 27.8734V41.2839C19.5607 43.9612 17.3903 46.1316 14.713 46.1316C12.0356 46.1316 9.86523 43.9612 9.86523 41.2839V17.1363C9.86523 15.9059 10.2332 14.89 10.969 14.0897C11.7048 13.2892 12.7504 12.8887 14.1071 12.8887C15.8668 12.8887 17.4973 13.5514 18.998 14.8764L37.2637 31.193V17.7364C37.2637 15.0591 39.4341 12.8887 42.1114 12.8887C44.7887 12.8887 46.9591 15.0596 46.9591 17.7369C46.9591 24.2243 46.9591 29.2645 46.9591 35.5485C46.9591 35.7437 46.4408 35.4163 46.4408 35.614C45.7829 35.3521 45.6027 34.4201 45.6027 36.465Z",
  fill: "#363537"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.8756 46.6387C76.0862 46.6387 74.3265 45.3787 72.595 42.8579L61.4062 26.5138C60.4059 25.0527 60.3779 23.1716 61.0012 21.5142C61.8109 19.361 62.0499 17.3268 61.62 15.4978C61.3432 14.3205 62.1119 12.8887 63.3213 12.8887C63.8155 12.8887 64.2776 13.1337 64.5549 13.5428L73.0974 26.1469C75.4733 29.6524 80.6351 29.6599 83.0211 26.1612L90.2865 15.5081C91.4042 13.8692 93.2597 12.8887 95.2434 12.8887H101.086C101.666 12.8887 102.206 13.1608 102.498 13.6617C102.821 14.2146 102.771 14.9163 102.404 15.4407L83.1563 42.9042C81.4248 45.3938 79.6644 46.6387 77.8756 46.6387Z",
  fill: "#005374"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.1854 7.7154C56.1854 7.7154 52.9683 7.08604 52.8089 7.7154C52.6495 8.3445 52.2291 8.29475 51.9148 7.7154C51.6446 7.21697 48.9621 6.93103 49.0793 7.7154C48.4121 7.99572 47.8935 8.97124 48.8622 9.70534C64.2678 21.3792 33.2276 50.013 0 52.0002C43.3675 49.5291 70.0515 20.1836 56.1854 7.7154Z",
  fill: "#1F7DA2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.2278 8.11745C56.2278 9.01652 55.4502 9.74538 54.4908 9.74538C53.5315 9.74538 52.7539 9.01652 52.7539 8.11745C52.7539 7.21825 53.5315 6.48926 54.4908 6.48926C55.4502 6.48926 56.2278 7.21825 56.2278 8.11745Z",
  fill: "#1F7DA2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.5343 4.12513C51.5343 4.88686 50.8755 5.50417 50.0631 5.50417C49.2505 5.50417 48.5918 4.88686 48.5918 4.12513C48.5918 3.36354 49.2505 2.74609 50.0631 2.74609C50.8755 2.74609 51.5343 3.36354 51.5343 4.12513Z",
  fill: "#1F7DA2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.4118 6.59427C48.4118 7.53261 47.6003 8.29316 46.5998 8.29316C45.5985 8.29316 44.7871 7.53261 44.7871 6.59427C44.7871 5.65619 45.5985 4.89551 46.5998 4.89551C47.6003 4.89551 48.4118 5.65619 48.4118 6.59427Z",
  fill: "#005374"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.0657 8.40604C52.0657 9.38916 51.2153 10.186 50.1668 10.186C49.118 10.186 48.2676 9.38916 48.2676 8.40604C48.2676 7.42292 49.118 6.62598 50.1668 6.62598C51.2153 6.62598 52.0657 7.42292 52.0657 8.40604Z",
  fill: "#1F7DA2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.5807 4.85981C53.5807 5.24526 53.2475 5.55752 52.8363 5.55752C52.4251 5.55752 52.0918 5.24526 52.0918 4.85981C52.0918 4.4745 52.4251 4.16211 52.8363 4.16211C53.2475 4.16211 53.5807 4.4745 53.5807 4.85981Z",
  fill: "#005374"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.481 4.53912C44.481 4.60786 44.4736 4.67502 44.4595 4.74009C44.3603 5.1944 43.9314 5.53612 43.4173 5.53612C42.8297 5.53612 42.3535 5.08966 42.3535 4.53912C42.3535 3.98832 42.8297 3.54199 43.4173 3.54199C44.0048 3.54199 44.481 3.98832 44.481 4.53912Z",
  fill: "#005374"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.4731 2.22518C45.4731 2.61049 45.1398 2.92275 44.7287 2.92275C44.3175 2.92275 43.9844 2.61049 43.9844 2.22518C43.9844 1.83973 44.3175 1.52734 44.7287 1.52734C45.1398 1.52734 45.4731 1.83973 45.4731 2.22518Z",
  fill: "#1F7DA2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.7897 3.46443C47.7897 3.84975 47.4564 4.16214 47.0451 4.16214C46.6341 4.16214 46.3008 3.84975 46.3008 3.46443C46.3008 3.07899 46.6341 2.7666 47.0451 2.7666C47.4564 2.7666 47.7897 3.07899 47.7897 3.46443Z",
  fill: "#005374"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.885 0.453657C31.885 0.704249 31.6682 0.907314 31.401 0.907314C31.1338 0.907314 30.917 0.704249 30.917 0.453657C30.917 0.203066 31.1338 0 31.401 0C31.6682 0 31.885 0.203066 31.885 0.453657Z",
  fill: "#005374"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.5713 2.06991C42.5713 2.66562 42.0561 3.1486 41.4205 3.1486C40.7848 3.1486 40.2695 2.66562 40.2695 2.06991C40.2695 1.4742 40.7848 0.991211 41.4205 0.991211C42.0561 0.991211 42.5713 1.4742 42.5713 2.06991Z",
  fill: "#1F7DA2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.184 1.60502C35.184 1.97318 34.8656 2.27156 34.4728 2.27156C34.0802 2.27156 33.7617 1.97318 33.7617 1.60502C33.7617 1.23699 34.0802 0.938477 34.4728 0.938477C34.8656 0.938477 35.184 1.23699 35.184 1.60502Z",
  fill: "#005374"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.0209 0.507162C28.0209 0.671343 27.8788 0.804363 27.7037 0.804363C27.5286 0.804363 27.3867 0.671343 27.3867 0.507162C27.3867 0.342981 27.5286 0.209961 27.7037 0.209961C27.8788 0.209961 28.0209 0.342981 28.0209 0.507162Z",
  fill: "#005374"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.7515 5.09305C45.1227 5.35779 44.541 5.36878 44.4602 4.74073C44.3793 4.11242 42.7562 5.50534 43.418 5.53676C44.0795 5.56818 44.7873 5.92116 44.7914 6.67673C44.7946 7.26655 46.3013 4.86132 45.7515 5.09305Z",
  fill: "#005374"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.3411 1.63215C43.7151 1.98814 42.8284 1.67653 42.2993 1.37305C41.45 1.52806 41.7447 3.34793 42.1812 2.88026C42.6812 2.34478 43.5113 2.22079 44.2632 2.76845C44.3614 2.32396 44.519 1.92136 44.3411 1.63215Z",
  fill: "#1F7DA2"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.5479 0.194183C36.7545 0.0128515 37.0788 0.0228019 37.2724 0.216572C37.4659 0.410342 37.4554 0.71422 37.2487 0.895683C37.0422 1.07701 36.7177 1.0672 36.5243 0.873295C36.3307 0.679787 36.3413 0.375646 36.5479 0.194183Z",
  fill: "#005374"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.8309 1.6342C38.1503 1.35376 38.6516 1.36934 38.951 1.6685C39.25 1.96806 39.2337 2.43795 38.9142 2.71852C38.5948 2.99883 38.093 2.98339 37.7943 2.68409C37.4948 2.38466 37.5115 1.91451 37.8309 1.6342Z",
  fill: "#005374"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 52,
    viewBox: "0 0 225 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.4452082d.svg";
export { ForwardRef as ReactComponent };